export default __webpack_public_path__ + "static/RecklessNeue-Book-cbf6149e363d5e4b4a175dc8699facd1.woff2";